module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/responsible/responsible-edit/responsible-edit.component.css
// module id = ./src/app/components/responsible/responsible-edit/responsible-edit.component.css
// module chunks = main